import { formatNumber } from "@hitit/utils";

export function formatKrwNumber(amount: number) {
    return formatNumber(amount).replace(/,/g, ",")
}
export const dataURLtoFile = (dataurl: string, fileName: string) => {
    const arr = dataurl.split(",")
    const mime = (arr[0].match(/:(.*?);/) as RegExpMatchArray)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n);


    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
};